module.exports = __webpack_public_path__ + "img/5.8ab58e1d.png";